export const _TENANT = {
    SIGNUP_REQUEST: 'USER_REGISTER_REQUEST',
    SIGNUP_SUCCESS: 'USER_REGISTER_SUCCESS',
    SIGNUP_FAILURE: 'USER_REGISTER_FAILURE',

    LOGOUT: 'USER_LOGOUT',

    GETALL_REQUEST: 'USER_GETALL_REQUEST',
    GETALL_SUCCESS: 'USER_GETALL_SUCCESS',
    GETALL_FAILURE: 'USER_GETALL_FAILURE',

    DELETE_REQUEST: 'USER_DELETE_REQUEST',
    DELETE_SUCCESS: 'USER_DELETE_SUCCESS',
    DELETE_FAILURE: 'USER_DELETE_FAILURE',
    
    UPDATE_REQUEST: 'TENANT_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'TENANT_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'TENANT_UPDATE_FAILURE'
};